import { ReactTFC } from "../../../../../../utils/fp/missing-ts-parts";
import { css } from "@emotion/react";
import React from "react";
import { CSS_COLORS } from "../../../../../../styles/styles-css-variables";

export const PaymentIcon: ReactTFC<{ paymentName: string }> = props => {
  return (
    <img
      css={css`
        height: 30px;
        border: 1px solid ${CSS_COLORS.OtherGray2024};
        border-radius: 6px;
      `}
      src={`https://checkoutshopper-live.adyen.com/checkoutshopper/images/logos/${props.paymentName}.svg`}
      alt={props.paymentName}
    />
  );
};
